import React from 'react';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/system';

const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
  30% { transform: translateY(-4px); opacity: 1; }
`;

const TypingIndicator: React.FC = () => {
    return (
        <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center', py: '0.4rem', px: '0.2rem' }}>
            {[0, 1, 2].map((i) => (
                <Box
                    key={i}
                    sx={{
                        width: 7,
                        height: 7,
                        borderRadius: '50%',
                        backgroundColor: '#999',
                        animation: `${bounce} 1.2s ease-in-out infinite`,
                        animationDelay: `${i * 0.15}s`,
                    }}
                />
            ))}
        </Box>
    );
};

export default TypingIndicator;
